import { useState } from 'react';
import { useHistory } from 'react-router';
import { useIsMounted, useOverlayContext } from 'seagull';
import { routes } from '~/constants';
import { useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { handleRequest } from '~/infra/utils';
export const useAgreementTriage = (param)=>{
    let { extraction: extractionFromProps, conversationId, dismissModal, testIds } = param;
    const [extraction, setExtraction] = useState(()=>extractionFromProps.clone());
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { api } = useStoreActions();
    const { showErrorToast } = useOverlayContext();
    const { t } = useLocaleKeys();
    const history = useHistory();
    const isMounted = useIsMounted();
    const submitCreate = async ()=>{
        setIsSubmitting(true);
        const result = await handleRequest(api.agreementImport.create({
            conversationId,
            extraction
        }));
        if (!isMounted()) return;
        if (result.success) {
            dismissModal();
            history.push(routes.draft(result.data.draftId));
        } else {
            showErrorToast(t.agreementImport.triageModal.submitError(), testIds.SubmitErrorToast());
            setIsSubmitting(false);
        }
    };
    return {
        extraction,
        setExtraction,
        isSubmitting,
        submitCreate
    };
};
